import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'sca-number-tile',
  templateUrl: './number-tile.component.html',
  styleUrls: ['./number-tile.component.scss'],
  imports: [MatProgressSpinnerModule]
})
export class NumberTileComponent {
  @Input("scaTitle") title: string = '';
  @Input("scaApplicationsCount") applicationsCount: number = 0;
  @Input("scaIsLoading") isLoading: boolean = false;
  @Output("scaClick") onClickOuput: EventEmitter<void> = new EventEmitter<void>();
  @Input("scaCssClass") cssClass: string = '';

  constructor(private _dashboardService: DashboardService) { }

  public onClick(): void {
    this.onClickOuput.next();
  }
}
